import { analyticAPI } from "@/services/api";
import { post } from "@/services/request";

export const logEvent = (eventName, eventProperties) => {
  post(analyticAPI, {
    eventName,
    eventProperties
  });
};
